import React from "react";

function Icon(data) {
  return (
      <svg width={data.w} height={data.h} xmlns="http://www.w3.org/2000/svg">
        <path d="M18 32.34 9.66 24l-2.83 2.83L18 38l24-24-2.83-2.83z" fill="#45B931" />
    </svg>

  );
}

export default Icon;
